// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","headerContainer":"App_headerContainer__pnJrl","mainContainer":"App_mainContainer__Zrnhn"};